import { ShopperAgentChannelsConfigSchema } from "@redotech/redo-shopper-agent-settings-common/channel-config";
import { ShopperAgentCooldownConfigSchema } from "@redotech/redo-shopper-agent-settings-common/cooldown-config";
import { ShopperAgentDiscountConfigSchema } from "@redotech/redo-shopper-agent-settings-common/discount-config";
import { ShopperAgentEmailConfigSchema } from "@redotech/redo-shopper-agent-settings-common/email-config";
import { ShopperAgentEscalationConfigSchema } from "@redotech/redo-shopper-agent-settings-common/escalation-config";
import { ShopperAgentHumanQueueConfigSchema } from "@redotech/redo-shopper-agent-settings-common/human-queue-config";
import { ShopperAgentIMessageConfigSchema } from "@redotech/redo-shopper-agent-settings-common/imessage-config";
import { ShopperAgentPersonaConfigSchema } from "@redotech/redo-shopper-agent-settings-common/persona-config";
import { ShopperAgentRcsConfigSchema } from "@redotech/redo-shopper-agent-settings-common/rcs-config";
import { ShopperAgentReplyConfigSchema } from "@redotech/redo-shopper-agent-settings-common/reply-config";
import { AgentReturnWindowGraceSchema } from "@redotech/redo-shopper-agent-settings-common/return-window-grace";
import { ShopperAgentReturnsConfigSchema } from "@redotech/redo-shopper-agent-settings-common/returns-config";
import { SkillConfigSchema } from "@redotech/redo-shopper-agent-settings-common/skill-config";
import { ShopperAgentSupervisorConfigSchema } from "@redotech/redo-shopper-agent-settings-common/supervisor-config";
import * as z from "zod";

/** Live (or draft-preferring) shopper-agent settings returned to merchant editors. */
export const PublishedShopperAgentSettingsSchema = z.object({
  enabled: z.boolean(),
  returnsConfig: ShopperAgentReturnsConfigSchema.optional(),
  returnWindowGrace: AgentReturnWindowGraceSchema.optional(),
  channels: ShopperAgentChannelsConfigSchema.optional(),
  replyConfig: ShopperAgentReplyConfigSchema.optional(),
  recoverConfig: ShopperAgentHumanQueueConfigSchema.optional(),
  escalationConfig: ShopperAgentEscalationConfigSchema.optional(),
  iMessageConfig: ShopperAgentIMessageConfigSchema.optional(),
  personaConfig: ShopperAgentPersonaConfigSchema.optional(),
  discountConfig: ShopperAgentDiscountConfigSchema.optional(),
  /** The linked discount even when the Commerce Agent's own discount switch is off. */
  linkedDiscountConfig: ShopperAgentDiscountConfigSchema.optional(),
  cooldownConfig: ShopperAgentCooldownConfigSchema.optional(),
  supervisorConfig: ShopperAgentSupervisorConfigSchema.optional(),
  skills: z.record(z.string(), SkillConfigSchema).optional(),
  rcsConfig: ShopperAgentRcsConfigSchema.optional(),
  emailConfig: ShopperAgentEmailConfigSchema.optional(),
});

export const getPublishedShopperAgentSettings = {
  name: "getPublishedShopperAgentSettings" as const,
  input: z.object({}),
  output: z.object({
    /** Null when nothing is published (agent off). */
    settings: PublishedShopperAgentSettingsSchema.nullable(),
  }),
};
